const themeConfig = {
	shape: {
		borderRadius: 3,
	},
	breakpoints: {
		keys: ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"],
		values: {
			xxs: 0,
			xs: 620,
			sm: 800,
			md: 1100,
			lg: 1270,
			xl: 1420,
			xxl: 1536,
		},
		unit: "px",
	},
	palette: {
		body: {
			main: "#f5f5f5",
			light: "#ffffff",
			dark: "#e0e0e0",
			contrastText: "#000000",
		},
		appBar: {
			public: {
				main: "#FFFFFF",
				light: "#FFFFFF",
				dark: "#FFFFFF",
				contrastText: "#2C2C6D",
			},
			private: {
				main: "#FFFFFF",
				light: "#FFFFFF",
				dark: "#FFFFFF",
				contrastText: "#2C2C6D",
			},
		},
		titleBar: {
			public: {
				main: "#2C2C6D",
				light: "#2C2C6D",
				dark: "#2C2C6D",
				contrastText: "#ffffff",
				gradient: `url('/texture.png'), linear-gradient(90deg, #2b2c6d 30%, #0d8bb1)`,
			},
		},
		primary: {
			main: "#2C2C6D",
			light: "#2C2C6D",
			dark: "#2C2C6D",
		},
		secondary: {
			main: "#B8A57A",
			light: "#B8A57A",
			dark: "#B8A57A",
		},
		underline: {
			main: "#B8A57A",
		},
		footer: {
			main: "#1E1E1E",
			light: "#1E1E1E",
			dark: "#1E1E1E",
		},
		colophon: {
			main: "#191919",
			light: "#191919",
			dark: "#191919",
			contrastText: "#BABABA",
		},
		link: {
			main: "#016197",
			light: "#0472b0",
			dark: "#00466e",
		},
		excerptLink: {
			main: "#000000",
			light: "#000000",
			dark: "#000000",
		},
		excerptUnderline: "#B8A57A",
		sidebarUnderline: "#B8A57A",
		tab: {
			main: "#2C2C6D",
			contrastText: "#ffffff",
		},
		highlight: {
			light: "rgba(255, 255, 255, 0.85)",
		},
	},
	typography: {
		fontSize: 16,
		fontFamily: [
			"Open Sans",
			"-apple-system",
			"BlinkMacSystemFont",
			'"Segoe UI"',
			'"Helvetica Neue"',
			"Arial",
			"sans-serif",
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(","),
		subtitle2: {
			fontFamily: "Open Sans",
			fontWeight: 600,
			opacity: 1,
			color: "#000000",
		},
		nav: {
			textTransform: "uppercase",
			fontWeight: 600,
			fontSize: "0.9rem",
			paddingTop: "1rem",
		},
		h1: {
			fontFamily: "Open Sans",
			fontWeight: 400,
			fontSize: "2rem",
		},
		h2: {
			fontWeight: 600,
			fontSize: "1.8rem",
		},
		h3: {
			fontWeight: 600,
			fontSize: "1.6rem",
		},
		h4: {
			fontWeight: 600,
			fontSize: "1.4rem",
		},
		h5: {
			fontWeight: 600,
			fontSize: "1.2rem",
		},
		h6: {
			fontWeight: 600,
			fontSize: "1rem",
		},
		fontWeightBold: 600,
		titleBar: {
			fontFamily: "Open Sans",
		},
		subtitle1: {
			fontStyle: "normal",
			fontWeight: 400,
			lineHeight: 1.5,
			letterSpacing: "-0.01562em",
			fontSize: "1.3rem",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				text: {
					fontWeight: 600,
				},
			},
		},
	},
	cloverleaf: {
		flush: true,
		googleFont: "Open+Sans:ital,wght@0,400;0,600;1,400;1,600",
		sidebar: {
			style: "box",
			underline: "#B8A57A",
		},
		list: {
			underline: "#B8A57A",
			underlineStyle: "rounded",
		},
		navbar: {
			borderRadius: 9,
			align: "right",
		},
		footer: {
			maxCols: 5,
		},
		single: {
			containerStyle: "div",
			style: "flush",
		},
		brand: {
			size: 120,
		},
		components: {
			More: {
				variant: "text",
				color: "primary",
			},
		},
		css: `
			.highlight .thumbnail figure {
                padding-top: 55%;
      }

      html.is-public body {
        background-color: #333d47;
        color: #000000;
      }

      html.is-public .desktop-brand .brand.as-logo > span {
        height: 140px !important;
        padding-top: 18px !important;
        padding-bottom: 18px !important;
      }

      #single-body {
        background-color: #f5f5f5;
      }

      /* #___gatsby .call-to-action.layout-bottom {
        background-image: url('/texture3.png?v=1');
        background-size: auto 100%;
      } */

      #___gatsby .call-to-action.layout-bottom .filter-1 {
        opacity: 0.5;
      }

      #___gatsby .call-to-action.layout-bottom .filter-2 {
        opacity: 0.4;
      }

      #___gatsby .call-to-action.layout-bottom .filter-3 {
        opacity: 0.5;
      }

      #footer .MuiGrid-container .MuiGrid-item {
        padding-top: 20px !important;
      }

      #footer .MuiGrid-container .MuiGrid-item:first-child .text > * {
        margin-bottom: 15px;
      }

      #footer .MuiGrid-container .MuiGrid-item img[src*="logo"] {
        height: 53px;
        width: auto;
        margin-right: 30px;
      }

      #footer .MuiGrid-container img[src*="twitter"] {
        height: 24px;
        width: auto;
      }

      #footer .colophon {
        padding-top: 15px;
        margin-top: 15px;
      }

      #___gatsby #single-body .closing-section {
        padding-bottom: 40px;
      }

      #___gatsby #single-body .closing-section .image-block.square {
        padding-top: 80%;
      }

      #___gatsby #single-body .closing-section > .MuiContainer-root {
        margin-top: 80px;
        max-width: 1200px;
      }

      #___gatsby #single-body .closing-section > .title-bar + .MuiContainer-root {
        margin-top: 40px;
      }

      #___gatsby #single-body .closing-section > .title-bar {
        margin-top: 80px;
      }

      #___gatsby #single-body .closing-section .highlight.style-frame .inner {
        padding: 30px 24px;
      }

      .sidebar-section .MuiPaper-root > *:not(:first-child) {
        margin-top: 15px;
      }

      .main-container {
        padding-bottom: 60px !important;
      }

      #___gatsby .MuiAccordionSummary-expandIconWrapper {
        color: #ffffff;
      }

      html.type-node--personnel .main-section h2,
      html.type-node--personnel .main-section .heading-h2 {
        font-size: 1.4rem;
        margin-top: 50px !important;
      }

      html.type-node--personnel .main-section .text blockquote {
        margin-left: 0;
      }

      html.type-node--event .MuiTypography-h1 {
        font-weight: 600;
        margin-top: 30px;
      }

      html.type-node--event time.MuiTypography-overline {
        font-size: 1.3rem;
        font-weight: 400;
        line-height: 1.5;
        text-transform: none;
      }

      html.type-node--fellowship .MuiAccordionDetails-root {
        padding: 36px;
      }
      html.type-node--fellowship .MuiAccordionSummary-root .MuiTypography-root {
        font-size: 1.2rem;
        font-weight: 600;
      }

      html.type-node--fellowship .MuiAccordionSummary-root {
        background-color: #d4d4d4;
        color: #242424;
      }

      body .text blockquote {
        background-color: #D0EDF6;
        border-left: 16px solid #2493B5;
        font-size: 1.3em;
        padding: 32px 40px;
        margin: 2% 0;
      }

      .main-section .MuiAvatar-root {
        transform: scale(1.25);
      }

      .excerpt-content h3 {
        padding-top: 5px;
      }

      .desktop-nav + .tools-nav.MuiBox-root {
        border-bottom: 1px solid;
        border-image: linear-gradient(to right, #ffffff, #2c2c6d) 1 100;
      }

      .closing-section.MuiBox-root > .cta-wrap.MuiBox-root {
        background-position: center center;
      }

      .cta-wrap.MuiBox-root > div.call-to-action {
        border-top: 4px solid #b8a57a;
        margin-top: 5rem;
        padding-top: 24px;
        padding-bottom: 24px;

        background-color: #2b2c6d;
        background-image: url(./20220121_W-in-library_019.jpeg);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
      }

      .cta-wrap.MuiBox-root > div.call-to-action > div.MuiContainer-root > div > div {
        padding-left: unset;
        padding-right: unset;
        max-width: unset;
      }

      #single-body > main > .closing-section.MuiBox-root a,
      #single-body > main > .closing-section.MuiBox-root button {
        border-radius: unset;
        text-align: start;
        box-shadow: unset;
        text-transform: none;
        justify-content: start;
        padding-top: 1rem;
        padding-bottom: 1rem;
      }

      #single-body > main > .closing-section.MuiBox-root > .MuiPaper-root.title-bar {
        background-color: #242424;
        background-image: url(./texture.png), linear-gradient(to right, #2b2c6d 100%, #76236c);
        background-repeat: repeat, repeat;
        background-size: auto, auto;
      }

      .type-node--publication #___gatsby .chapter-body .title-bar header > strong {
        display: none;
      }

      .type-node--publication #___gatsby .chapter-body .titles-box h1 {
        font-weight: bold;
      }

      .type-node--publication #___gatsby .print-publication h1 {
        font-weight: bold;
        font-size: 260%;
      }

      #___gatsby .desktop-nav nav a {
        color: #000;
      }

      @media (min-width: 1270px) {
        .type-node--publication .main-container > .MuiContainer-root:first-of-type {
          max-width: 1270px !important;
        }
      }

      @media (max-width: 600px) {
        .cta-wrap {
          background-size: auto !important;
          background-position: top center !important;
          background-repeat: no-repeat !important;
        }
      }


		`,
	},
};
module.exports = themeConfig;
